import { combineReducers } from "redux";

import sales from "./sales";

const reducer = combineReducers({
    sales
});

export default reducer;
